var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partition_page"},[_c('vx-card',[_c('div',[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Main"}},[_c('Main')],1),_c('vs-tab',{attrs:{"label":"Sections"}},[_c('Sections')],1)],1)],1),_c('div',{staticClass:"actions w-full"},[_c('vs-button',{staticClass:"unimacs_button"},[_vm._v("\n        Submit\n      ")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }